import { useField, useFormikContext } from 'formik';
import { type ChangeEvent, type RefObject } from 'react';

import { Checkbox } from '../../InputFields/Checkbox';

interface FormikCheckboxProps {
  name: string;
  label: string;
  importanceRef?: RefObject<HTMLDivElement> | null;
  childFields?: string[];
}

export const FormikCheckbox: React.FC<FormikCheckboxProps> = ({
  name,
  label,
  importanceRef = null,
  childFields = [],
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const isChecked = e.target.checked;
    setFieldValue(name, isChecked);
    if (!meta.initialValue && !isChecked && Array.isArray(childFields)) {
      for (const f of childFields) {
        setFieldValue(f, '');
      }
    }
  };

  return (
    <Checkbox
      id={field.name}
      name={field.name}
      importanceRef={importanceRef}
      onBlur={field.onBlur}
      label={label}
      onChange={handleChange}
      checked={field.value as boolean}
    />
  );
};
